/**
 * Kopiert Text in die Zwischenablage; Fallback über ein temporäres Textarea +
 * `execCommand('copy')` für Kontexte ohne Clipboard-API (z. B. http).
 */
export async function copyTextToClipboard(text: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    textarea.remove();
  }
}
